module.exports = __webpack_public_path__ + "img/icon_persona.0bf7adf4.svg";